import { Injectable } from '@angular/core';

import { ClientStorage, ClientStorageService } from './../../../utils';
import { UrlsService } from './../url/urls.service';

/* Copyright IBM Corp. 2017 */
const LOGGER = 'StorageService';

@Injectable({ providedIn: 'root' })
export class StorageService extends ClientStorageService implements ClientStorage {

  constructor(aUrlsService: UrlsService) {
    super(aUrlsService);
  }
}
